module.exports = __webpack_public_path__ + "img/hh-logo.ff9e74a9.svg";